module.exports = __webpack_public_path__ + "static/media/mcqMomentDiagram1.664432cd.svg";